import ptBR from './pt-BR'
import enUs from './en-US'

const resources = {
  'pt-BR': ptBR,
  'en-US': enUs
}

export default resources
